import { Redirect, generatePath, useRouteMatch } from 'react-router-dom';
import { CANVAS_ROOT } from 'automation-ui-canvas/constants/AbsolutePaths';
import { FlowViewConfigs } from 'automation-ui-canvas/containers/flow-views/FlowViewConfigs';
import { useGetHasScope, useGetIsUngated } from 'automation-ui-core/hooks/authHooks';
import FlowViewDataManager from 'automation-ui-canvas/containers/flow-views/FlowViewDataManager';
import { useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const FlowViewContainer = ({
  scrollElementRef,
  flow
}) => {
  const getIsUngated = useGetIsUngated();
  const getHasScope = useGetHasScope();
  const {
    params
  } = useRouteMatch();
  const config = useMemo(() => params.viewId && FlowViewConfigs[params.viewId], [params.viewId]);
  if (!config || !config.getIsAvailable({
    getIsUngated,
    getHasScope,
    isClassicWorkflow: flow.isClassicWorkflow
  })) {
    return /*#__PURE__*/_jsx(Redirect, {
      to: generatePath(CANVAS_ROOT, {
        screen: 'edit',
        flowId: params.flowId
      })
    });
  }
  return /*#__PURE__*/_jsx(FlowViewDataManager, {
    flow: flow,
    config: config,
    canvasScrollElementRef: scrollElementRef
  });
};
export default FlowViewContainer;